















































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import IReadingCommunicationCategory from "@/interfaces/IReadingCommunicationCategory";
import CommunicationCategoryDetail from "@/components/CommunicationCategoryDetail.vue";
import HelpContent from "../HelpContent.vue";
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";

@Component
({
  components:{
    CommunicationCategoryDetail,
    HelpContent,
    LeftClickOptionMenu
  }
})
export default class CommunicationsCategories extends Vue {
  loading: boolean = false;
  resultsItems = new Array<IReadingCommunicationCategory>();
  modal_helpCommunicationCategories: string = "modal-helpCommunicationCategories"
  filter: any = {
    idCategory: "",
    typeId: "",
    name: "",
  };
  idCategorySelected: string = "";
  commCtgFields = [
                {
                key: 'icon-search',
                label: '',
                sortable: false
            },
            {
                key: 'name',
                label: 'Category',
                sortable: false
            },
            {
                key: 'type',
                label: 'Communication Type',
                sortable: false
            }
        ];

  //pacchetto per menu tasto destro su dettaglio entita'
  leftClickOptionMenuUrl: string = "/communicationsCategories/";
  leftClickOptionMenuUrlArgument: string = "idCategory";
  handleClick (event, item) {
      (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
  }

  async mounted() {
    await this.getCommunicationCategoriesWithFilter(this.filter);
    if (this.$route.params.id) {
      let idCategoryUrlArgument = this.$route.params.id;
      this.openCategory(idCategoryUrlArgument);
    }
  }

  async getCommunicationCategoriesWithFilter(filter){
    this.loading = true;
    try {
      let response = await axios({
          method: 'post',
          url: General.GetApiUrl('/api/Communication/GetCommunicationCategoriesWithFilter'),
          responseType: 'json',
          withCredentials: true,
          data: {
            filter: filter,
          }
      });

      if (response.data) 
       this.resultsItems =response.data;
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  openCategory(idCommunicationCategorySelected : string){
    this.idCategorySelected = idCommunicationCategorySelected;
    this.$bvModal.show("category-detail-update-modal");
  }

}
